export default {
  elfNotice1: {
    e: 'https://appresource.opple.com/media/business/2379/20240425113718_62.png',
    d: 'https://appresource.opple.com/media/business/2379/20240425113814_47.png',
    z: 'https://appresource.opple.com/media/panel/2023/09/12/20230912185546_90.png',
  },
  elfNotice2: {
    e: 'https://appresource.opple.com/media/business/58/20240425112927_79.png',
    d: 'https://appresource.opple.com/media/business/2379/20240425113527_16.png',
    z: 'https://appresource.opple.com/media/panel/2023/09/12/20230912185546_90.png',
  },
  enocean1: {
    e: 'https://appresource.opple.com/media/business/3214/20240626161531_56.png',
    d: 'https://appresource.opple.com/media/business/3214/20240626161635_3.png',
    z: 'https://appresource.opple.com/media/business/3214/20240626161422_1.png',
    fr: 'https://appresource.opple.com/media/business/361240/20260610110308_15.png',
  },
  enocean2: {
    e: 'https://appresource.opple.com/media/business/58/20240426110748_81.png',
    d: 'https://appresource.opple.com/media/business/58/20240426110823_65.png',
    z: 'https://appresource.opple.com/media/business/58/20240426110700_3.png',
  },
  elfNotice3: {
    e: 'https://appresource.opple.com/media/business/333972/20260702132610_71.png',
    d: 'https://appresource.opple.com/media/business/333972/20260702132630_57.png',
    z: 'https://appresource.opple.com/media/business/333972/20260702132542_74.png',
  },
}